import otu from '../Images/Workex/otu.png';
import harveys from '../Images/Workex/harveys.png';
import intouch from '../Images/Workex/intouch.png';
import uber from '../Images/Workex/uber.png';
import marigold from '../Images/Workex/marigold.png';

const workex = [
    {
        "id": 1,
        "title": "Research Associate",
        "organization": "Ontario Tech University",
        "start": "May 2021",
        "end": "Present",
        "highlights": [
            "C/C++", "Javascript", "Python", "Machine learning"
        ],
        "description": [
            "Coodinated with professors and Teaching Assistants to complete industry sponsored research projects",
            "Worked on successful completion of Obstacle tracking and WSN Optimization",
            "Took part in writing research papers and presentations to senior engineers",
            "Refer to the projects page"
        ],
        "logo": otu
    },
    {
        "id": 2,
        "title": "Peer tutor",
        "organization": "Ontario Tech University",
        "start": "September 2021",
        "end": "March 2021",
        "highlights": [
            "Teaching"
        ],
        "description": [
            "Tutored students in previously excelled engineering courses",
            "Assisted lower year in problem solving and studying techniques",
            "Communicated with pass leaders to create a well-coordinated learning environment"
        ],
        "logo": otu
    },
    {
        "id": 3,
        "title": "Junior Javascript Developer",
        "organization": "In touch guru solutions",
        "start": "May 2020",
        "end": "August 2020",
        "highlights": [
            "Javascript", "HTML", "CSS"
        ],
        "description": [
            "Assisted Senior consultant with database management and coding in JavaScript",
            "Communicated with clients and documented requirements"
        ],
        "logo": intouch
    },
    {
        "id": 4,
        "title": "Cashier",
        "organization": "Harvey's",
        "start": "May 2019",
        "end": "August 2019",
        "highlights": [
            "Customer Service", "Time Management"
        ],
        "description": [
            "Received proper training and worked at the grill and fryer to prepare food for customers",
            "Developed superior time management skills to adapt quickly to fast paced environment",
            "Ensured satisfactory food quality and proper hygienic measures were maintained"
        ],
        "logo": harveys
    },
    {
        "id": 5,
        "title": "Manager",
        "organization": "Marigold Indian Bistro",
        "start": "May 2019",
        "end": "October 2019",
        "highlights": [
            "Customer Service", "Management"
        ],
        "description": [
            "Supervised and superintended a team of multiple servers to provide customer satisfaction",
            "Great organization skills developed through handling phone calls and cash transactions",
            "Calculated weekly sale statistics and ensured proper cleanliness measures were taken"
        ],
        "logo": marigold
    },
    {
        "id": 6,
        "title": "Delivery Partner",
        "organization": "Uber Eats",
        "start": "May 2019",
        "end": "Present",
        "highlights": [
            "Customer Service"
        ],
        "description": [
            "Retrieved food from restaurants and delivered to customers before the designated time",
            "Achieved a high level of customer satisfaction (98%)"
        ],
        "logo": uber
    },

]

export default workex;